// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import api from '@/http/index'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'

axios.defaults.crossDomain = true
axios.defaults.withCredentials = true
console.log('2019121702')
/* 获取服务器配置 */
axios.get('./static/config/APIConfig.json').then((res) => {
  let baseServer = res.data
  Vue.prototype.baseServer = baseServer
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}).catch((error) => {
  console.log('获取config失败：', error)
  let baseServer = {
    cmsServer: 'http://10.155.93.214:9090',
    uploadServer: 'http://10.155.93.214:39090'
  }
  Vue.prototype.baseServer = baseServer
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})

Vue.config.productionTip = false
Vue.use(api)
Vue.use(ElementUI)



// WEBPACK FOOTER //
// ./src/main.js